module.exports = __webpack_public_path__ + "static/media/cashbackBlackFrinday2020.45337ad1.png";